/* eslint-disable react-hooks/rules-of-hooks */
import { Alert, Upload, Typography, Row, Col, Button, DatePicker, Form, Tag, Input, Select, Space, Card, Avatar, InputNumber, Radio, message } from 'antd';
import React, { useEffect, useState } from 'react';
import { DeleteOutlined } from '@ant-design/icons';
import axios from 'axios';
import dayjs from 'dayjs';
import SmallCalendar from '../../schedule_timeline/SmallCalendar';
import { useFormulaType } from './FormulaType/controller/FormulaTypeController';
import { useBillPaymentGradeClassStudent } from './BillPayment/controller/useBillPaymentGradeClassStudent';
import { useSystemHoliday } from "./SystemHoliday/Controller/useSystemHolidayController";
const { RangePicker } = DatePicker;
const setParamsFilter = (obj) => {
    return Object.entries(obj).reduce((all, [key, value]) => (!value === null || value === "") ? { ...all } : { ...all, [key]: value }, {})
}
const AddTuitionForm = ({
    formCount = 0,
    select_mode = false,
    elseHidden = false,
    defaultValue,
    propsForm,
    hasBackgroundColor = false,
    onFormFinish = () => { },
    onTotalChange = () => { },
    edit = false,
    canExport,
    setCanExport = () => { },
    selectDate = [],
    setSelectDate = () => { },
    ...props

}) => {
    const [count, setCount] = useState(0);
    const [show, set_show] = useState(false);
    const [holiday, set_holiday] = useState([]);
    const [smallCalendarKey, setSmallCalendarKey] = useState(0)
    const [form] = propsForm ? [propsForm] : Form.useForm();
    const [classTimeRange, setClassTimeRange] = useState([])
    const [weekdayValue, setWeekdayValue] = useState([])
    const weekname = ['日', '一', '二', '三', '四', '五', '六']
    const [formulaOption, setFormulaOption] = useState([])
    const [classOptions, setClassOptions] = useState([])
    const [makeUpDateValue, setMakeUpDateValue] = useState([])
    const [propsHoliday, setPropsHoliday] = useState([])
    const formHeaderStyle = (hasBackgroundColor) => {
        if (hasBackgroundColor) {
            return {
                backgroundColor: "#edf3ff",
            }
        }
        return {
            backgroundColor: 'transparent',
            border: '0px',
            padding: '0px'
        }
    }
    const TeacherData = () => {
        let teacher_data = []
        if (propsForm) {
            teacher_data = propsForm.getFieldValue("teacher_data") ?? []
        }
        else {
            teacher_data = form.getFieldValue("teacher_data") ?? []
        }
        let temp = teacher_data.map((value) => {
            return <Tag color='gold'>
                {value?.teacher_name}
            </Tag>
        })
        return <Space wrap>{temp}</Space>
    }
    const LastEditUserNameData = () => {
        let last_edit_user_name = ""
        if (propsForm) {
            last_edit_user_name = propsForm.getFieldValue("last_edit_user_name") ?? []
        }
        else {
            last_edit_user_name = form.getFieldValue("last_edit_user_name") ?? []
        }
        return <Tag color="cyan">
            {last_edit_user_name}
        </Tag>
    }
    const WeekTimeData = () => {
        let week_time_data = []
        if (propsForm) {
            week_time_data = propsForm.getFieldValue("week_time_data") ?? []
        }
        else {
            week_time_data = form.getFieldValue("week_time_data") ?? []
        }
        let temp = week_time_data.map((value) => {
            return <Tag color='blue'>
                星期{weekname[value?.week_id]} {value?.time_start}-{value?.time_end}
            </Tag>
        })
        return <Space wrap>{temp}</Space>
    }
    const onHolidayChange = (e) => {
        let selected_week = []

        e && e.map((item, i) => {
            selected_week.push({
                ...item,
                text: `${item.date}(${item.week})為${item.description}`,
            })
        })

        set_holiday(selected_week);
    }
    const onWeekTimeDataChange = () => {
        let week_time_data = []
        if (propsForm) {
            week_time_data = propsForm.getFieldValue("week_time_data") ?? []
        }
        else {
            week_time_data = form.getFieldValue("week_time_data") ?? []
        }
        week_time_data.reduce((unique, item) => unique.includes(item) ? unique : [...unique, item], []);
        setWeekdayValue((pre) => {
            return week_time_data.map((value) => {
                return value?.week_id % 7
            })
        })
        setSmallCalendarKey(pre => pre + 1)
    }
    const getFormula = (param, sort, filter, checklist) => {

        axios
            .get(`/Salary/formula/dataLoad`, {
                params: {
                    ...param,
                    // cur_page: param?.current,
                    // size: param?.pageSize,
                    // custom_filter_key: checklist,
                    // custom_filter_value: param?.keyword,
                    // order: sort && Object.entries(sort).map(([map_key, map_value]) => ({ column: map_key, type: map_value }))
                }
            })
            .then((response) => {
                let data = response.data.data.aRows
                setFormulaOption((pre) => {
                    let temp = data.map((value) => {
                        let FormulaRule_data = value?.FormulaRule_data
                        let item = FormulaRule_data.find((ele) => true)
                        let fNumeric = item?.fNumeric || value?.iDefaultValue || 0
                        let iFormulaType = value?.iFormulaType
                        let tActivationTime = value?.tActivationTime
                        let cName = value?.cName

                        return {
                            ...item,
                            label: `${value?.cName}(${fNumeric})`,
                            value: value?.iFormulaID,
                            fNumeric: fNumeric,
                            iFormulaType,
                            tActivationTime,
                            cName
                        }
                    })
                    return temp
                })
            })
            .finally(() => {
            })
    }
    const getClass = () => {
        axios
            .get('/cramSchool/api/class', {
            })
            .then((response) => {
                let data = response.data.data ?? []
                data = data.filter((element) => {
                    return element?.grade_class_data.length > 0
                })
                setClassOptions(data)

            })
    }
    const getLesson = (lesson_id) => {
        if (!!lesson_id) {
            axios
                .get('/cramSchool/api/lesson', {
                    params: {
                        lesson_id: lesson_id
                    }
                })
                .then((response) => {
                    let data = response.data.data
                    let lessonData = data.find((ele) => true)
                    let lesson_Salary_TABLE_Formula_data = lessonData?.lesson_Salary_TABLE_Formula_data
                    let newLesson_Salary_TABLE_Formula_data = lesson_Salary_TABLE_Formula_data.map((value) => {
                        return {
                            ...value,
                            name: value?.lesson_name,
                            tempPrice: value?.fNumeric ?? 0,
                            amount: 1,
                            fNumeric: 0,
                            cOperator: "+"
                        }
                    })

                    // let lesson_Salary_TABLE_Formula_ids = lesson_Salary_TABLE_Formula_data.map((value) => {
                    //     return value?.lesson_Salary_TABLE_Formula_id
                    // })
                    // console.log({
                    //     formulaOption,
                    //     newLesson_Salary_TABLE_Formula_data
                    // })
                    if (propsForm) {
                        propsForm.setFieldValue("lesson_Salary_TABLE_Formula_data", newLesson_Salary_TABLE_Formula_data)
                    }
                    else {
                        form.setFieldValue("lesson_Salary_TABLE_Formula_data", newLesson_Salary_TABLE_Formula_data)
                    }

                    setCount(pre => pre + 1)
                })
        }
        else {
            if (propsForm) {
                propsForm.setFieldValue("lesson_Salary_TABLE_Formula_data", [])
            }
            else {
                form.setFieldValue("lesson_Salary_TABLE_Formula_data", [])
            }
        }
    }
    const getSubTotal = (data) => {
        let subtotalTemp = (data?.tempPrice * data?.amount) || 0
        if (data?.cOperator === "+") {
            subtotalTemp = subtotalTemp + (data?.fNumeric || 0)
        }
        else if (data?.cOperator === "-") {
            subtotalTemp = subtotalTemp - (data?.fNumeric || 0)
        }
        else if (data?.cOperator === "*") {
            subtotalTemp = subtotalTemp * (data?.fNumeric || 0)
        }
        else if (data?.cOperator === "/") {
            subtotalTemp = subtotalTemp / (data?.fNumeric || 0)
        }
        return subtotalTemp
    }
    const onChangeiFormulaID = (fieldIndex, selected_id) => {
        let formlistData = propsForm.getFieldValue("lesson_Salary_TABLE_Formula_data")
        let tempValue = formulaOption.find((element) => {
            return element?.value === selected_id
        })
        let fNumeric = tempValue?.fNumeric || 0
        let iFormulaType = tempValue?.iFormulaType
        let iSign = tempValue?.iSign ?? 1
        let tActivationTime = tempValue?.tActivationTime
        let cName = tempValue?.cName
        let iUnitID = tempValue?.iUnitID
        let iUnitValue = tempValue?.iUnitValue
        let cUnitName = tempValue?.cUnitName
        let newData = formlistData.map((val, index) => {
            if (index === fieldIndex) {
                return {
                    ...val,
                    tempPrice: fNumeric,
                    iFormulaType: iFormulaType,
                    iSign,
                    tActivationTime,
                    cName,
                    iUnitID,
                    iUnitValue,
                    cUnitName
                }
            }
            else {
                return {
                    ...val
                }
            }
        })
        propsForm.setFieldValue("lesson_Salary_TABLE_Formula_data", newData)

        autoCalculateCourseFees(selectDate.length - holiday.length)

    }
    const onFinish = (values) => {

        let grade_class_id = values?.grade_class_id
        let bill_payment_grade_class_id = values?.bill_payment_grade_class_id
        let payment_time = values.payment_time
        let old_payment_time = values.old_payment_time
        let payment_time_start = dayjs(payment_time[0]).format("YYYY-MM-DD")
        let payment_time_end = dayjs(payment_time[1]).format("YYYY-MM-DD")
        let old_payment_time_start = dayjs(old_payment_time[0]).format("YYYY-MM-DD")
        let old_payment_time_end = dayjs(old_payment_time[1]).format("YYYY-MM-DD")
        let payment_limit_time = values.payment_limit_time
        let payment_limit_time_start = dayjs(payment_limit_time[0]).format("YYYY-MM-DD")
        let payment_limit_time_end = dayjs(payment_limit_time[1]).format("YYYY-MM-DD")
        let bill_payment_id = values?.bill_payment_id
        let default_class_count = values?.default_class_count
        let class_id = values?.class_id
        let year = values?.year
        let year_serial = values?.year_serial
        let bill_payment_grade_class_data = [
            {
                "payment_time_start": payment_time_start,//填外層的
                "payment_time_end": payment_time_end,//填外層的
                "bill_payment_grade_class_id": bill_payment_grade_class_id,//填外層的
                "iValue": values?.default_class_count //原本的基底堂數,

            }
        ]

        //patch 
        let lesson_Salary_TABLE_Formula_data = values.lesson_Salary_TABLE_Formula_data.map((values) => {
            return {
                bill_payment_grade_class_Salary_TABLE_Formula_id: values?.bill_payment_grade_class_Salary_TABLE_Formula_id,
                cName: values?.cName,
                iSign: values?.iSign,
                iFormulaType: values?.iFormulaType,
                grade_class_id,
                payment_time_start,
                payment_time_end,
                payment_limit_time_start,
                payment_limit_time_end,
                amount: values?.amount,
                cOperator: values?.cOperator,
                fNumeric: values?.fNumeric ?? 0,
                iBaseFormulaID: values?.iFormulaID,
                iFormulaID: values?.iFormulaID_children
            }
        })
        let student_data = (values?.student_data || []).map((student) => {
            let bill_payment_grade_class_student_Salary_TABLE_Formula_data = student.bill_payment_grade_class_student_Salary_TABLE_Formula_data.map((value) => {
                let FormulaRule_data_obj = {
                    amount: value?.amount,
                    cName: value?.cName,
                    iSign: value?.iSign,
                    iFormulaType: value?.iFormulaType,
                    cOperator: value?.cOperator,
                    fNumeric: value?.fNumeric ?? 0,
                    iBaseFormulaID: value?.iFormulaID,
                    iFormulaID: value?.iFormulaID_children,
                    bill_payment_grade_class_student_Salary_TABLE_Formula_id: value?.bill_payment_grade_class_student_Salary_TABLE_Formula_id
                }
                FormulaRule_data_obj = setParamsFilter(FormulaRule_data_obj)
                return {
                    ...FormulaRule_data_obj
                }
            })
            let bill_student_installment_data = (student?.bill_student_installment_data || []).map((value) => {
                let payment_limit_start_time = value?.payment_limit_time[0] ? dayjs(value?.payment_limit_time[0]).format("YYYY-MM-DD") : null
                let payment_limit_end_time = value?.payment_limit_time[0] ? dayjs(value?.payment_limit_time[1]).format("YYYY-MM-DD") : null

                let new_bill_student_installment_data = {
                    bill_student_cost: value?.bill_student_cost,
                    bill_student_installment_id: value?.bill_student_installment_id,
                    bill_student_installment_serial: value?.bill_student_installment_serial,
                    payment_limit_start_time: payment_limit_start_time,
                    payment_limit_end_time: payment_limit_end_time
                }
                new_bill_student_installment_data = setParamsFilter(new_bill_student_installment_data)
                return {
                    ...new_bill_student_installment_data
                }
            })
            return {
                ...student,
                grade_class_id: student?.grade_class_id,
                grade_class_student_id: student?.grade_class_student_id,
                bill_payment_grade_class_student_Salary_TABLE_Formula_data: bill_payment_grade_class_student_Salary_TABLE_Formula_data,
                bill_student_installment_data
            }
        })
        let data = [
            {
                year,
                year_serial,
                payment_limit_time_start,
                payment_limit_time_end,
                bill_payment_id,
                old_payment_time_start,
                old_payment_time_end,
                payment_time_start,
                payment_time_end,
                bill_payment_grade_class_id: bill_payment_grade_class_id,
                "grade_class_id": grade_class_id,
                "bill_payment_grade_class_Salary_TABLE_Formula_data": lesson_Salary_TABLE_Formula_data,
                "student_data": student_data,
                bill_payment_grade_class_data,
                select_date: selectDate,
                default_class_count,
                class_id
            }
        ]
        // console.log({ data })
        onFormFinish(data)
    }
    const getClassTotal = (count) => {
        let temp = propsForm.getFieldValue("lesson_Salary_TABLE_Formula_data") ?? []
        let listLength = temp.length
        let total = 0
        let otherTotal = 0
        for (let i = 0; i < listLength; i++) {
            let data = propsForm.getFieldValue(['lesson_Salary_TABLE_Formula_data', i])
            if (data?.iFormulaType && data?.iFormulaType === 3) {
                total += getSubTotal(data)
            } else {
                otherTotal += getSubTotal(data)
            }
        }
        propsForm?.setFieldValue("classTotal", (total + otherTotal) ?? 0)
        propsForm?.setFieldValue("CourseFees", (total) ?? 0)
        propsForm?.setFieldValue("OtherFees", (otherTotal) ?? 0)
        return {
            "classTotal": (total + otherTotal) ?? 0,
            "CourseFees": (total) ?? 0,
            "OtherFees": (otherTotal) ?? 0
        }
    }
    const onClassChange = (class_id) => {
        let formValues = null
        let classData = classOptions.find((ele) => ele.class_id === class_id)
        let lesson_class_data = classData?.lesson_class_data ?? []
        let lesson_class_data_first = lesson_class_data.find(ele => true)
        let lesson_id = lesson_class_data_first?.lesson_id
        let grade_class_data = classData?.grade_class_data
        let grade_class_data_first = grade_class_data.find((ele => true))
        let grade_class_id = grade_class_data_first?.grade_class_id
        if (propsForm) {
            formValues = propsForm.getFieldsValue()
            propsForm.resetFields()
            propsForm.setFieldsValue({
                ...formValues,
                ...classData,
                ...lesson_class_data_first,
                grade_class_id,
                lesson_id
            })
        }
        else {
            formValues = form.getFieldsValue()
            form.resetFields()
            form.setFieldsValue({
                ...formValues,
                ...classData,
                ...lesson_class_data_first,
                grade_class_id,
                lesson_id

            })
        }
        getLesson(lesson_id)
        onWeekTimeDataChange()
        setClassTimeRange([formValues?.payment_time_start, formValues?.payment_time_end])

    }
    const onChangeStudentiFormulaID = (fieldIndex, subFieldIndex, selected_id) => {
        let formStudentData = []
        let formListStudentData = {}
        let formSubListBillPaymentFormulaData = []
        let formSubListData = {}
        if (propsForm) {
            formStudentData = propsForm.getFieldValue('student_data')
            formListStudentData = propsForm.getFieldValue(['student_data', fieldIndex])
            formSubListBillPaymentFormulaData = propsForm.getFieldValue(['student_data', fieldIndex, 'bill_payment_grade_class_student_Salary_TABLE_Formula_data'])
            formSubListData = propsForm.getFieldValue(['student_data', fieldIndex, 'bill_payment_grade_class_student_Salary_TABLE_Formula_data', subFieldIndex])
        }
        else {
            formStudentData = form.getFieldValue('student_data')
            formListStudentData = form.getFieldValue(['student_data', fieldIndex])
            formSubListBillPaymentFormulaData = form.getFieldValue(['student_data', fieldIndex, 'bill_payment_grade_class_student_Salary_TABLE_Formula_data'])
            formSubListData = form.getFieldValue(['student_data', fieldIndex, 'bill_payment_grade_class_student_Salary_TABLE_Formula_data', subFieldIndex])
        }
        let tempValue = formulaOption.find((element) => {
            return element?.value === selected_id
        })
        let fNumeric = tempValue?.fNumeric || 0
        let iFormulaType = tempValue?.iFormulaType
        let iSign = tempValue?.iSign ?? 1
        let tActivationTime = tempValue?.tActivationTime
        let cName = tempValue?.cName
        formSubListData = {
            ...tempValue,
            ...formSubListData,
            iFormulaType,
            iSign,
            tActivationTime,
            cName,
            tempPrice: fNumeric
        }
        let newFormula_dataData = formSubListBillPaymentFormulaData.map((value, index) => {
            if (index === subFieldIndex) {
                return formSubListData
            }
            else {
                return {
                    ...value
                }
            }
        })

        formListStudentData = {
            ...formListStudentData,
            bill_payment_grade_class_student_Salary_TABLE_Formula_data: newFormula_dataData
        }
        let newformStudentData = formStudentData.map((value, index) => {
            if (index === fieldIndex) {
                return formListStudentData
            }
            else {
                return {
                    ...value
                }
            }
        })
        if (propsForm) {
            propsForm.setFieldValue("student_data", newformStudentData)
        }
        else {
            form.setFieldValue("student_data", newformStudentData)

        }
    }
    const getStudentSubTotal = (fieldIndex, subFieldIndex, count) => {
        let data = {}
        if (propsForm) {
            data = propsForm.getFieldValue(['student_data', fieldIndex, 'bill_payment_grade_class_student_Salary_TABLE_Formula_data', subFieldIndex])
        }
        else {
            data = form.getFieldValue(['student_data', fieldIndex, 'bill_payment_grade_class_student_Salary_TABLE_Formula_data', subFieldIndex])
        }

        let subtotalTemp = (data?.tempPrice * data?.amount) ?? 0
        if (data?.cOperator === "+") {
            subtotalTemp = subtotalTemp + (data?.fNumeric || 0)
        }
        else if (data?.cOperator === "-") {
            subtotalTemp = subtotalTemp - (data?.fNumeric || 0)
        }
        else if (data?.cOperator === "*") {
            subtotalTemp = subtotalTemp * (data?.fNumeric || 0)
        }
        else if (data?.cOperator === "/") {
            subtotalTemp = subtotalTemp / (data?.fNumeric || 0)
        }

        return subtotalTemp ?? 0
    }
    const getStudentTotal = (fieldIndex, count) => {
        let CourseFees = 0
        let OtherFees = 0
        let temp = []

        if (propsForm) {
            CourseFees = propsForm.getFieldValue("CourseFees") ?? 0
            OtherFees = propsForm.getFieldValue("OtherFees") ?? 0
            temp = propsForm.getFieldValue(['student_data', fieldIndex])
        }
        else {
            CourseFees = form.getFieldValue("CourseFees") ?? 0
            OtherFees = propsForm.getFieldValue("OtherFees") ?? 0
            temp = form.getFieldValue(['student_data', fieldIndex])
        }
        let val = temp?.bill_payment_grade_class_student_Salary_TABLE_Formula_data
        let listLength = val?.length
        let is_free_tuition = temp?.is_free_tuition // 0 不是免學費 // 1 免學費 

        CourseFees = (CourseFees || 0)
        OtherFees = (OtherFees || 0)
        for (let i = 0; i < listLength; i++) {
            let data = val[i]
            let subtotalTemp = (data?.tempPrice * data?.amount) ?? 0
            if (data?.cOperator === "+") {
                subtotalTemp = subtotalTemp + (data?.fNumeric || 0)
            }
            else if (data?.cOperator === "-") {
                subtotalTemp = subtotalTemp - (data?.fNumeric || 0)
            }
            else if (data?.cOperator === "*") {
                subtotalTemp = subtotalTemp * (data?.fNumeric || 0)
            }
            else if (data?.cOperator === "/") {
                subtotalTemp = subtotalTemp / (data?.fNumeric || 1)
            }

            if (data?.iFormulaType === 3) {
                CourseFees += subtotalTemp
            }
            else {
                OtherFees += subtotalTemp
            }
        }
        if (is_free_tuition == 1) {
            CourseFees = 0
        }
        return {
            'CourseFees': CourseFees,
            'OtherFees': OtherFees
        }
    }
    const countAbsentTotal = (studentfieldIndex, lostValue) => {
        let student_data = []
        let FormulaTypeOptionFirst = FormulaTypeOption.find(ele => true)
        let FormulaType = FormulaTypeOptionFirst?.iFormulaType
        let thisStudentData
        let lesson_Salary_TABLE_Formula_datas = []
        if (propsForm) {
            student_data = propsForm.getFieldValue('student_data')
            thisStudentData = propsForm.getFieldValue(['student_data', studentfieldIndex])
            lesson_Salary_TABLE_Formula_datas = propsForm.getFieldValue('lesson_Salary_TABLE_Formula_data')
        }
        else {
            student_data = form.getFieldValue('student_data')
            thisStudentData = form.getFieldValue(['student_data', studentfieldIndex])
            lesson_Salary_TABLE_Formula_datas = form.getFieldValue('lesson_Salary_TABLE_Formula_data')
        }
        let bill_payment_grade_class_student_Salary_TABLE_Formula_datas = thisStudentData?.bill_payment_grade_class_student_Salary_TABLE_Formula_data ?? []
        let isCourseFee = lesson_Salary_TABLE_Formula_datas.filter((element => element.iFormulaType === FormulaType))
        let needDeleteiFormulaID = isCourseFee.map((ele) => {
            return ele?.iFormulaID
        })
        let costList = isCourseFee.map((FormulaData) => {
            return {
                ...FormulaData,
                amount: (lostValue) * (-1)
            }
        })
        bill_payment_grade_class_student_Salary_TABLE_Formula_datas = bill_payment_grade_class_student_Salary_TABLE_Formula_datas.filter((ele) => {
            return !needDeleteiFormulaID.includes(ele.iFormulaID)
        })
        let new_student_Salary_TABLE_Formula_datas = costList.concat(bill_payment_grade_class_student_Salary_TABLE_Formula_datas)
        thisStudentData = {
            ...thisStudentData,
            bill_payment_grade_class_student_Salary_TABLE_Formula_data: new_student_Salary_TABLE_Formula_datas
        }
        student_data = student_data.map((data, index) => {
            if (index === studentfieldIndex) {
                return {
                    ...thisStudentData,
                }
            }
            else {
                return {
                    ...data,
                }
            }

        })

        if (propsForm) {
            propsForm.setFieldValue('student_data', student_data)
        }
        else {
            form.setFieldValue('student_data', student_data)
        }
    }
    const counTtuitionDeductionClasses = (studentfieldIndex, lostValue) => {
        let student_data = []
        let FormulaTypeOptionFirst = FormulaTypeOption.find(ele => true)
        let FormulaType = FormulaTypeOptionFirst?.iFormulaType
        let thisStudentData
        let lesson_Salary_TABLE_Formula_datas = []
        if (propsForm) {
            student_data = propsForm.getFieldValue('student_data')
            thisStudentData = propsForm.getFieldValue(['student_data', studentfieldIndex])
            lesson_Salary_TABLE_Formula_datas = propsForm.getFieldValue('lesson_Salary_TABLE_Formula_data')
        }
        else {
            student_data = form.getFieldValue('student_data')
            thisStudentData = form.getFieldValue(['student_data', studentfieldIndex])
            lesson_Salary_TABLE_Formula_datas = form.getFieldValue('lesson_Salary_TABLE_Formula_data')
        }
        let bill_payment_grade_class_student_Salary_TABLE_Formula_datas = thisStudentData?.bill_payment_grade_class_student_Salary_TABLE_Formula_data ?? []
        let isCourseFee = lesson_Salary_TABLE_Formula_datas.filter((element => element.iFormulaType === FormulaType))
        let needDeleteiFormulaID = isCourseFee.map((ele) => {
            return ele?.iFormulaID
        })
        let costList = isCourseFee.map((FormulaData) => {
            return {
                ...FormulaData,
                amount: (lostValue) * (-1)
            }
        })
        bill_payment_grade_class_student_Salary_TABLE_Formula_datas = bill_payment_grade_class_student_Salary_TABLE_Formula_datas.filter((ele) => {
            return !needDeleteiFormulaID.includes(ele.iFormulaID)
        })
        let new_student_Salary_TABLE_Formula_datas = costList.concat(bill_payment_grade_class_student_Salary_TABLE_Formula_datas)
        new_student_Salary_TABLE_Formula_datas = new_student_Salary_TABLE_Formula_datas.filter((ele) => {
            return ele.amount !== 0
        })
        thisStudentData = {
            ...thisStudentData,
            bill_payment_grade_class_student_Salary_TABLE_Formula_data: new_student_Salary_TABLE_Formula_datas
        }
        student_data = student_data.map((data, index) => {
            if (index === studentfieldIndex) {
                return {
                    ...thisStudentData,
                }
            }
            else {
                return {
                    ...data,
                }
            }

        })

        if (propsForm) {
            propsForm.setFieldValue('student_data', student_data)
        }
        else {
            form.setFieldValue('student_data', student_data)
        }
    }
    const autoCalculateCourseFees = (amount) => {
        let FormulaTypeOptionFirst = FormulaTypeOption.find(ele => true)
        let FormulaType = FormulaTypeOptionFirst?.iFormulaType
        let formlistData = propsForm.getFieldValue("lesson_Salary_TABLE_Formula_data")
        let newLesson_Salary_TABLE_Formula_data = formlistData.map((value) => {
            if (value.iFormulaType === FormulaType) {
                if (value.cUnitName === "堂") {
                    return {
                        ...value,
                        amount: amount
                    }
                }
                else if (value.cUnitName === "期") {
                    return {
                        ...value,
                        amount: 1
                    }
                }
                else {
                    return {
                        ...value
                    }
                }

            }
            else {
                return {
                    ...value
                }
            }
        })
        if (propsForm) {
            propsForm.setFieldValue('lesson_Salary_TABLE_Formula_data', newLesson_Salary_TABLE_Formula_data)
        }
        else {
            form.setFieldValue('lesson_Salary_TABLE_Formula_data', newLesson_Salary_TABLE_Formula_data)
        }
        getClassTotal()
        //test
        let new_student_data = []
        let student_data = propsForm.getFieldValue("student_data")
        new_student_data = student_data.map((value, index) => {
            let total = getStudentTotal(index, 0)
            let bill_student_installment_data = value?.bill_student_installment_data || []
            let payment_limit_time = form.getFieldValue("payment_limit_time")
            let installment_count = value?.installment_count || 1
            let new_bill_student_installment_data = []
            new_bill_student_installment_data = countInstallmentCount({ bill_student_installment_data, installment_count, total, payment_limit_time })
            return {
                ...value,
                bill_student_installment_data: new_bill_student_installment_data
            }
        })
        form.setFieldValue("student_data", new_student_data)
    }


    const exportBillPaymentClassPdf = (fieldIndex) => {
        let grade_class_student_id = propsForm.getFieldValue(['student_data', fieldIndex, 'grade_class_student_id'])
        let bill_payment_id = propsForm.getFieldValue('bill_payment_id')
        let year = propsForm.getFieldValue('year')
        let year_serial = propsForm.getFieldValue('year_serial')
        const blob = getBillPaymentGradeClassStudentPdf({
            grade_class_student_id,
            bill_payment_id,
            year,
            year_serial,
            selectDate
        })
    }
    const countInstallmentCount = ({ bill_student_installment_data, installment_count, total, payment_limit_time }) => {
        let new_bill_student_installment_data = []
        let installmentAmount = Math.floor(total['CourseFees'] / installment_count)
        let installmentRemainder = total['CourseFees'] % installment_count + total['OtherFees']
        if (bill_student_installment_data.length < installment_count) {
            while (bill_student_installment_data.length < installment_count) {
                bill_student_installment_data.push({})
            }
        }
        let startTime = dayjs(payment_limit_time[0])
        let endTime = dayjs(payment_limit_time[1])
        new_bill_student_installment_data = bill_student_installment_data
            .filter((ele, index) => index < installment_count)
            .map((values, index2) => {
                if (index2 === 0) {
                    return {
                        ...values,
                        bill_student_installment_serial: index2 + 1,
                        bill_student_cost: installmentAmount + installmentRemainder,
                        payment_limit_time: payment_limit_time
                    }
                }
                else {
                    startTime = endTime.add(1, 'days')
                    endTime = startTime.add(1, 'month').date(10)
                    return {
                        ...values,
                        bill_student_installment_serial: index2 + 1,
                        bill_student_cost: installmentAmount,
                        payment_limit_time: [startTime, endTime]
                    }
                }
            })
        return new_bill_student_installment_data
    }

    const {
        getBillPaymentGradeClassStudentPdf,
        getSerialDateCrossHoliday,
        serialCrossHolidayData,
    } = useBillPaymentGradeClassStudent(
        {
            onFinish: () => { },
            onBefore: () => { }
        }
    )

    const {
        FormulaTypeOption,
        getFormulaTypeOption
    } = useFormulaType(
        {
            onFinish: () => { },
            onBefore: () => { }
        }
    )
    const {
        systemHolidaySettingDatas,
        getSystemHolidaySettingData,
    } = useSystemHoliday({
        onFinish: () => { },
        onBefore: () => { }
    })
    useEffect(() => {
        if (propsForm) {
            propsForm.setFieldsValue({ ...defaultValue })
        }
        else {
            form.setFieldsValue({ ...defaultValue })
        }

        let bill_payment_grade_class_Salary_TABLE_Formula_data = defaultValue?.bill_payment_grade_class_Salary_TABLE_Formula_data || []
        if (bill_payment_grade_class_Salary_TABLE_Formula_data.length === 0) {
            getLesson(defaultValue?.lesson_id)
        }
        else {
            setCount(pre => pre + 1)
        }

        if (!!defaultValue?.payment_time_start) {
            getFormula({
                is_near_now: 1,
                is_near_now_date: defaultValue?.payment_time_start
            })
        }
        onWeekTimeDataChange()
        let classTime = []
        let end = ''
        if (defaultValue?.payment_time_end) {
            end = dayjs(defaultValue?.payment_time_end, "YYYY-MM-DD")
            end = dayjs(end).format('YYYY-MM-DD')
            classTime = [defaultValue?.payment_time_start, end]
        }
        setClassTimeRange(classTime)
        getSerialDateCrossHoliday({
            grade_class_id: propsForm.getFieldValue("grade_class_id"),
            start_time: defaultValue?.payment_time_start,
            end_time: end
        })

    }, [props.open, defaultValue, formCount])

    useEffect(() => {
        getSystemHolidaySettingData({

        }).then((response) => {
            let data = response?.data
            let first_data = data.find((e) => true)
            let year = first_data?.holiday_setting_year
            let holiday_setting_holiday_data = first_data?.holiday_setting_holiday_data || []
            let else_holiday_data = first_data?.else_holiday_data || []
            let temp = holiday_setting_holiday_data.map((date) => {
                let datas = dayjs(date?.date).day()
                let week = ['天', '一', '二', '三', '四', '五', '六']
                console.log({week:week[datas]})
                return {
                    "holiday_id": date?.holiday_id,
                    "date": (date?.date).replaceAll('-', '/'),
                    "week": week[datas],
                    "isholiday": date?.isholiday === "true" ? "1" : "0",
                    "description": date?.description,
                    "year": year
                }
            })
            else_holiday_data.forEach((element) => {
                let datas = dayjs(element?.date).day()
                let week = ['天', '一', '二', '三', '四', '五', '六']
                temp.push({
                    "holiday_setting_holiday_id": element?.holiday_setting_holiday_id,
                    "date":( element?.date).replaceAll('-', '/'),
                    "week": week[datas],
                    "isholiday": "1",
                    "description": element?.description,
                    "year": year
                })
            })
            console.log({
                temp
            })
            setPropsHoliday(temp)
        })
        if (holiday.length !== 0) {
            set_show(true);
        }
    }, [
        // holiday
    ])


    useEffect(() => {
        getFormulaTypeOption({ cName: "課程費" })

        if (select_mode) {
            getClass()
        }
    }, [])
    useEffect(() => {
        autoCalculateCourseFees(selectDate.length)
    }, [selectDate, holiday])

    useEffect(() => {
      
        let serialCrossHolidayDataFirst = (serialCrossHolidayData || []).find((element) => {
            return true
        })
        let bill_payment_holiday_datas = serialCrossHolidayDataFirst?.bill_payment_holiday_data || []
        let selectDateTemp = []
        let makeUpDateValueTemp = []
        bill_payment_holiday_datas.forEach((element) => {
            if (element?.is_holiday === 1) {
                makeUpDateValueTemp.push({
                    "is_make_up": "0",
                    "original_date": element?.serial_day,
                })
            }
            else {
                selectDateTemp.push(element?.serial_day)
            }
        })
        setMakeUpDateValue(makeUpDateValueTemp)
        setSelectDate((pre) => {
            return selectDateTemp
        })
    }, [serialCrossHolidayData])
    return (
        <Row>
            <Col span={24}>
                <Form
                    scrollToFirstError={true}
                    form={propsForm ? propsForm : form}
                    onFieldsChange={(values) => {
                        setCanExport(false)
                        setCount(pre => pre + 1)
                        values.forEach(each_item => {
                            if (each_item.name.findLast(_ => true) === "installment") {
                                if (each_item.touched) {
                                    const name = each_item.name.filter((_, filter_index) => filter_index !== each_item.name.length - 1)
                                    let newValue = form.getFieldValue([...each_item.name])
                                    let installment_count = 0
                                    if (newValue === 1) {
                                        form.setFieldValue([...name, "installment"], newValue)
                                        form.setFieldValue([...name, "installment_count"], 2)
                                        installment_count = 2
                                    } else {
                                        form.setFieldValue([...name, "installment"], newValue)
                                        form.setFieldValue([...name, "installment_count"], 1)
                                        installment_count = 1

                                    }
                                    let total = getStudentTotal(name[1], 0)
                                    let temp = form.getFieldValue([...name])
                                    let bill_student_installment_data = temp?.bill_student_installment_data || []
                                    let payment_limit_time = form.getFieldValue("payment_limit_time")
                                    let new_bill_student_installment_data = []
                                    new_bill_student_installment_data = countInstallmentCount({ bill_student_installment_data, installment_count, total, payment_limit_time })
                                    form.setFieldValue([...name, "bill_student_installment_data"], new_bill_student_installment_data)
                                } else {
                                }
                            }
                            else if (each_item.name.findLast(_ => true) === "installment_count" && each_item.touched) {
                                const name = each_item.name.filter((_, filter_index) => filter_index !== each_item.name.length - 1)
                                let total = getStudentTotal(name[1], 0)
                                let temp = form.getFieldValue([...name])
                                let bill_student_installment_data = [...temp?.bill_student_installment_data] || []
                                let new_bill_student_installment_data = []
                                let payment_limit_time = form.getFieldValue("payment_limit_time")
                                new_bill_student_installment_data = countInstallmentCount({ bill_student_installment_data, installment_count: each_item?.value, total, payment_limit_time })
                                form.setFieldValue([...name, "bill_student_installment_data"], new_bill_student_installment_data)
                                if (each_item.value > 1) {
                                    form.setFieldValue([...name, "installment_count"], each_item.value)
                                    form.setFieldValue([...name, "installment"], 1)
                                } else {
                                    form.setFieldValue([...name, "installment_count"], each_item.value)
                                    form.setFieldValue([...name, "installment"], undefined)
                                }
                            }
                            else if (each_item.name.findLast(_ => true) === "is_free_tuition" && each_item.touched) {
                                const name = each_item.name.filter((_, filter_index) => filter_index < 2)
                                getClassTotal()
                                let total = getStudentTotal(name[1], 0)
                                let temp = form.getFieldValue([...name])
                                let bill_student_installment_data = temp?.bill_student_installment_data || []
                                let payment_limit_time = form.getFieldValue("payment_limit_time")
                                let installment_count = temp?.installment_count || 1
                                let new_bill_student_installment_data = []
                                new_bill_student_installment_data = countInstallmentCount({ bill_student_installment_data, installment_count, total, payment_limit_time })
                                form.setFieldValue([...name, "bill_student_installment_data"], new_bill_student_installment_data)
                            }
                            else if (each_item.name.includes("bill_payment_grade_class_student_Salary_TABLE_Formula_data") && each_item.touched) {
                                const name = each_item.name.filter((_, filter_index) => filter_index < 2)
                                getClassTotal()
                                let total = getStudentTotal(name[1], 0)
                                let temp = form.getFieldValue([...name])
                                let bill_student_installment_data = temp?.bill_student_installment_data || []
                                let payment_limit_time = form.getFieldValue("payment_limit_time")
                                let installment_count = temp?.installment_count || 1
                                let new_bill_student_installment_data = []
                                new_bill_student_installment_data = countInstallmentCount({ bill_student_installment_data, installment_count, total, payment_limit_time })
                                form.setFieldValue([...name, "bill_student_installment_data"], new_bill_student_installment_data)
                            } else {
                                const name = each_item.name.filter((_, filter_index) => filter_index < 2)
                                let total = getStudentTotal(name[1], 0)
                                let temp = form.getFieldValue([...name])
                                let bill_student_installment_data = temp?.bill_student_installment_data || []
                                let payment_limit_time = form.getFieldValue("payment_limit_time")
                                let installment_count = temp?.installment_count || 1
                                let new_bill_student_installment_data = []
                                new_bill_student_installment_data = countInstallmentCount({ bill_student_installment_data, installment_count, total, payment_limit_time })
                                // form.setFieldValue([...name, "bill_student_installment_data"], new_bill_student_installment_data)
                            }

                        })
                    }}
                    onFinish={(values) => {
                        onFinish(values)
                    }}
                >
                    <Row gutter={[8, 8]}>
                        <Col span={24}>
                            <Card
                                size='small'
                                style={{
                                    ...formHeaderStyle(hasBackgroundColor)
                                }}
                            >
                                <Row gutter={[10, 10]} >
                                    <Col span={24} hidden={elseHidden} >
                                        <Row gutter={[8, 10]} align={'middle'}>
                                            <Form.Item
                                                hidden
                                                name={"class_id"}
                                            >
                                                <Input />
                                            </Form.Item>
                                            <Form.Item
                                                hidden
                                                name={"grade_class_id"}
                                            >
                                                <Input />
                                            </Form.Item>
                                            <Form.Item
                                                hidden
                                                name={"year"}
                                            >
                                                <Input />
                                            </Form.Item>
                                            <Form.Item
                                                hidden
                                                name={"year_serial"}
                                            >
                                                <Input />
                                            </Form.Item>
                                            <Form.Item
                                                hidden
                                                name={"bill_payment_id"}
                                            >
                                                <Input />
                                            </Form.Item>
                                            <Form.Item
                                                hidden
                                                name={"bill_payment_grade_class_id"}
                                            >
                                                <Input />
                                            </Form.Item>

                                            <Col span={24}>
                                                <Typography.Title level={4}>
                                                    {Form.useWatch('year', propsForm ? propsForm : form)}年度
                                                    第{Form.useWatch('year_serial', propsForm ? propsForm : form)}期
                                                </Typography.Title>
                                            </Col>
                                            {
                                                select_mode && <Col span={24}>
                                                    <Form.Item
                                                        label="班級"
                                                        name={"class_id"}
                                                        rules={[
                                                            {
                                                                required: true,
                                                                message: "請選擇 （必填)"
                                                            }
                                                        ]}
                                                    >
                                                        <Select
                                                            style={{
                                                                width: '100%',
                                                            }}
                                                            popupMatchSelectWidth={false}
                                                            onChange={(value) => {
                                                                onClassChange(value)
                                                            }}
                                                            options={classOptions.map((value) => {
                                                                return {
                                                                    label: value.name,
                                                                    value: value?.class_id
                                                                }
                                                            })}
                                                        >
                                                        </Select>
                                                    </Form.Item>
                                                </Col>

                                            }
                                            <Col span={6}>
                                                <Form.Item
                                                    label="課程名稱"
                                                    name={"lesson_name"}
                                                >
                                                    {Form.useWatch('lesson_name', propsForm ? propsForm : form)}
                                                </Form.Item>
                                            </Col>
                                            {/* <Col span={6}> */}
                                            <Form.Item
                                                hidden
                                                label="課程編號"
                                                name={"lesson_id"}
                                            >
                                                {Form.useWatch('lesson_id', propsForm ? propsForm : form)}

                                            </Form.Item>
                                            {/* </Col> */}
                                            <Col span={6}>
                                                <Form.Item
                                                    label="班級名稱"
                                                    name={"class_name"}
                                                >
                                                    {Form.useWatch('class_name', propsForm ? propsForm : form)}

                                                </Form.Item>
                                            </Col>
                                            <Col span={6}>
                                                <Form.Item
                                                    label="授課老師"
                                                    name={"teacher_data"}
                                                >
                                                    {TeacherData()}
                                                </Form.Item>
                                            </Col>
                                            <Col span={6}>
                                                <Form.Item
                                                    label="經手人"
                                                    name={"last_edit_user_name"}

                                                >
                                                    {LastEditUserNameData()}
                                                </Form.Item>

                                            </Col>
                                            <Col span={24}>
                                                <Space align='start'>
                                                    <Form.Item
                                                        label={"每期上課堂數"}
                                                        rules={[
                                                            {
                                                                required: true,
                                                                message: "必填"
                                                            }
                                                        ]}
                                                        initialValue={32}
                                                        name={"default_class_count"}
                                                    >
                                                        <InputNumber />
                                                    </Form.Item>
                                                    <Typography.Text type='danger'>
                                                        * 若修改上課區間，後面期數的試算依據
                                                    </Typography.Text>
                                                </Space>
                                            </Col>

                                            <Col span={24} >
                                                <Form.Item
                                                    label="上課區間(舊)"
                                                    name={"old_payment_time"}
                                                    hidden
                                                >
                                                    <RangePicker
                                                        format={"YYYY-MM-DD"}
                                                    />
                                                </Form.Item>

                                            </Col>
                                            <Col span={12}>
                                                <Form.Item
                                                    label="上課區間"
                                                    name={"payment_time"}
                                                    rules={[
                                                        {
                                                            required: true,
                                                            message: "請輸入上課區間"
                                                        }
                                                    ]}
                                                >
                                                    <RangePicker
                                                        format={"YYYY-MM-DD"}
                                                        onChange={(_, dateString) => {
                                                            let classTime = []
                                                            let end = ''
                                                            if (dateString[1]) {
                                                                end = dayjs(dateString[1], "YYYY-MM-DD")
                                                                // end = dayjs(end).format('YYYY-MM-DD')
                                                                classTime = [dateString[0], dateString[1]]
                                                            }
                                                            if (dateString[0]) {
                                                                getFormula({
                                                                    is_near_now: 1,
                                                                    is_near_now_date: dateString[0]
                                                                })
                                                                getSerialDateCrossHoliday({
                                                                    grade_class_id: propsForm.getFieldValue("grade_class_id"),
                                                                    start_time: dateString[0],
                                                                    end_time: dateString[1]
                                                                })
                                                            }
                                                            setClassTimeRange(classTime)
                                                            setSmallCalendarKey((pre => pre + 1))
                                                        }}
                                                    />
                                                </Form.Item>

                                            </Col>
                                            <Col span={12}>
                                                <Form.Item
                                                    label="繳費期限"
                                                    name={"payment_limit_time"}
                                                    rules={[
                                                        {
                                                            required: true,
                                                            message: "請輸入繳費期限"
                                                        }
                                                    ]}
                                                >
                                                    <RangePicker
                                                        format={"YYYY-MM-DD"}

                                                    />
                                                </Form.Item>
                                            </Col>
                                            <Col span={24}>
                                                <Form.Item
                                                    label="授課時間"
                                                    name={"week_time_data"}
                                                >
                                                    {WeekTimeData()}
                                                </Form.Item>
                                            </Col>
                                            <Col>
                                                <Form.Item
                                                    hidden
                                                    name={"classTotal"}
                                                >
                                                </Form.Item>
                                            </Col>

                                            {show &&
                                                holiday && holiday.map((value, i) => {
                                                    return (
                                                        < Col span={12}>
                                                            <Alert message={value.text} type="warning" showIcon
                                                                action={
                                                                    <Space direction="vertical">
                                                                        {/* <Button size="small" type="primary">
                                                                            停課
                                                                        </Button> */}
                                                                    </Space>
                                                                } />
                                                        </Col>
                                                    )
                                                })
                                            }
                                            <Col span={24}>
                                                <Form.Item
                                                    label={"授課預覽"}
                                                >
                                                    <Row gutter={[8, 8]}>
                                                        <Col
                                                            lg={14}
                                                            md={16}
                                                            sm={24}
                                                            xs={24}
                                                        >
                                                            <SmallCalendar
                                                                isPropsGetHoliday={true}
                                                                propsHolidays={propsHoliday}
                                                                key={smallCalendarKey}
                                                                onHolidayChange={onHolidayChange}
                                                                date_range_values={classTimeRange}  // RangePicker 的 dateString value
                                                                default_weekday_value={weekdayValue}  // 星期幾：0是星期天，1是星期一，以此類推... 6是星期六
                                                                circle_item={[]}
                                                                class_name_value={Form.useWatch('lesson_name', propsForm ? propsForm : form)}  // 課程名稱
                                                                getSelectedDate={(dates) => {
                                                                    // console.log(dates)
                                                                    // setSelectDate(dates)
                                                                }}

                                                                // make_up_date_value={makeUpDateValue}
                                                                make_up_date_value={[]}

                                                            />
                                                        </Col>

                                                    </Row>
                                                </Form.Item>
                                            </Col>
                                            <Col
                                                lg={24}
                                                md={24}
                                                sm={24}
                                                xs={24}
                                            >
                                                <Space>

                                                </Space>
                                                上課日期：共{selectDate.length}堂 (不包含補習班假日)
                                                <Space wrap>
                                                    {selectDate.map((value) => (<Tag color='magenta'>{value}</Tag>))}
                                                </Space>
                                            </Col>
                                        </Row >
                                    </Col>
                                    <Col span={24}>
                                        班級繳費項目總和: {getClassTotal(count)['classTotal'] ?? 0}
                                    </Col>
                                    <Col span={24}>
                                        <Form.Item
                                        >
                                            <Form.List
                                                name={"lesson_Salary_TABLE_Formula_data"}
                                            >
                                                {(fields, { add, remove }) => (
                                                    <div
                                                        style={{
                                                            display: 'flex',
                                                            rowGap: 16,
                                                            flexDirection: 'column',
                                                        }}
                                                    >

                                                        <Button
                                                            onClick={() => add()}
                                                            type="primary"
                                                            style={{
                                                                marginBottom: 16,
                                                                color: 'white',
                                                                backgroundColor: '#2C73D2'
                                                            }}
                                                            shape='round'
                                                            data-function="add"
                                                        >
                                                            新增班級繳費明細
                                                        </Button>
                                                        {fields.map((field) => (
                                                            <Space wrap>
                                                                <Form.Item
                                                                    label="項目"
                                                                    name={[field.name, 'iFormulaID']}
                                                                    rules={[
                                                                        {
                                                                            required: true,
                                                                            message: "請選擇 （必填)"
                                                                        }
                                                                    ]}
                                                                >
                                                                    <Select
                                                                        popupMatchSelectWidth={false}
                                                                        options={formulaOption}
                                                                        onChange={(value) => {
                                                                            onChangeiFormulaID(field.name, value)
                                                                        }}
                                                                        disabled={propsForm.getFieldValue(['lesson_Salary_TABLE_Formula_data', field.name, "lesson_Salary_TABLE_Formula_id"])}
                                                                    >
                                                                    </Select>
                                                                </Form.Item>
                                                                <Form.Item
                                                                    hidden
                                                                    name={[field.name, "bill_payment_grade_class_Salary_TABLE_Formula_id"]}
                                                                >
                                                                    <InputNumber />
                                                                </Form.Item>
                                                                <Form.Item
                                                                    hidden
                                                                    name={[field.name, "iFormulaType"]}
                                                                >
                                                                    <Input />
                                                                </Form.Item>
                                                                <Form.Item
                                                                    name={[field.name, "iFormulaID_children"]}
                                                                    hidden
                                                                >
                                                                    <Input />
                                                                </Form.Item>
                                                                <Form.Item
                                                                    name={[field.name, "iUnitID"]}
                                                                    hidden
                                                                >
                                                                    <Input />
                                                                </Form.Item>
                                                                <Form.Item
                                                                    name={[field.name, "iUnitValue"]}
                                                                    hidden
                                                                >
                                                                    <Input />
                                                                </Form.Item>
                                                                <Form.Item
                                                                    label="cUnitName"
                                                                    name={[field.name, "cUnitName"]}
                                                                    hidden
                                                                >
                                                                    <Input />
                                                                </Form.Item>
                                                                <Form.Item
                                                                    hidden
                                                                    initialValue={1}
                                                                    name={[field.name, "iSign"]}
                                                                >
                                                                    <Input />
                                                                </Form.Item>
                                                                <Form.Item
                                                                    hidden
                                                                    initialValue={0}
                                                                    name={[field.name, "tempPrice"]}
                                                                >
                                                                    <InputNumber />
                                                                </Form.Item>
                                                                <Form.Item
                                                                >
                                                                    <>*</>
                                                                </Form.Item>
                                                                <Form.Item
                                                                    name={[field.name, "amount"]}
                                                                    rules={[
                                                                        {
                                                                            required: true,
                                                                            message: "請選擇 （必填)"
                                                                        }
                                                                    ]}
                                                                >
                                                                    <InputNumber />
                                                                </Form.Item>

                                                                <Form.Item
                                                                    initialValue={"+"}
                                                                    name={[field.name, 'cOperator']}
                                                                    rules={[
                                                                        {
                                                                            required: true,
                                                                            message: "請選擇 （必填)"
                                                                        }
                                                                    ]}
                                                                >
                                                                    <Select
                                                                        options={[
                                                                            {
                                                                                label: "+",
                                                                                value: "+"
                                                                            },
                                                                            {
                                                                                label: "-",
                                                                                value: "-"
                                                                            },
                                                                            {
                                                                                label: "*",
                                                                                value: "*"
                                                                            },
                                                                            {
                                                                                label: "/",
                                                                                value: "/"
                                                                            },
                                                                        ]}
                                                                        onChange={(e) => {
                                                                        }}
                                                                    ></Select>
                                                                </Form.Item>
                                                                <Form.Item
                                                                    initialValue={0}
                                                                    name={[field.name, "fNumeric"]}
                                                                >
                                                                    <InputNumber />
                                                                </Form.Item>
                                                                <Form.Item
                                                                >
                                                                    =
                                                                </Form.Item>
                                                                <Form.Item
                                                                    hidden
                                                                    name={[field.name, "subtotal"]}
                                                                >
                                                                    <Input disabled>

                                                                    </Input>
                                                                </Form.Item>
                                                                <Form.Item>
                                                                    {getSubTotal(propsForm.getFieldValue(['lesson_Salary_TABLE_Formula_data', field.name]), count) ?? 0}
                                                                </Form.Item>
                                                                <Form.Item
                                                                    name={[field.name, "lesson_Salary_TABLE_Formula_id"]}
                                                                >
                                                                </Form.Item>
                                                                <Form.Item>
                                                                    {
                                                                        !propsForm.getFieldValue(['lesson_Salary_TABLE_Formula_data', field.name, "lesson_Salary_TABLE_Formula_id"]) &&
                                                                        <DeleteOutlined
                                                                            style={{ cursor: 'pointer' }}
                                                                            onClick={() => {
                                                                                remove(field.name);
                                                                            }}
                                                                        />
                                                                    }
                                                                </Form.Item>
                                                            </Space>
                                                        ))}
                                                    </div>
                                                )}
                                            </Form.List>
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Card>
                        </Col>
                        <Col>
                            <Row>
                                <Col span={24}>
                                    <Form.List
                                        name={"student_data"}
                                        initialValue={[]}
                                    >
                                        {(fields, { add, remove }) => (
                                            <Row gutter={[8, 8]}>
                                                {
                                                    fields.map((field) => (
                                                        <Col span={24}>

                                                            <Card
                                                                size='small'
                                                                style={{
                                                                    backgroundColor: "#ebfce5"
                                                                }}
                                                            >
                                                                <Row>
                                                                    <Col>
                                                                        <Form.Item
                                                                            hidden
                                                                            name={"bill_payment_grade_class_student_id"}
                                                                        >
                                                                            <Input />
                                                                        </Form.Item>
                                                                    </Col>
                                                                    <Col
                                                                        span={24}
                                                                        style={{
                                                                            alignSelf: 'center'
                                                                        }}
                                                                    >
                                                                        <Row
                                                                            justify={'space-around'}
                                                                            align={'middle'}
                                                                        >
                                                                            <Col span={24}>
                                                                                <Row>
                                                                                    <Col span={4}>
                                                                                        <Space
                                                                                            direction={'horizontal'}
                                                                                            align={'center'}
                                                                                        >
                                                                                            <Avatar
                                                                                                size={'large'}
                                                                                            />
                                                                                            <Form.Item
                                                                                                name={[field.name, "student_name"]}
                                                                                                hidden
                                                                                            >
                                                                                                <Input />
                                                                                            </Form.Item>
                                                                                            <Typography.Title level={4}>
                                                                                                {propsForm ? propsForm.getFieldValue(['student_data', field.name])?.student_name : form.getFieldValue(['student_data', field.name])?.student_name}
                                                                                            </Typography.Title>
                                                                                        </Space>
                                                                                    </Col>
                                                                                    <Col span={6}>
                                                                                        <Space align='start'>
                                                                                            <Form.Item
                                                                                                label={"上一期缺席"}
                                                                                                name={[field.name, "absent_total"]}
                                                                                            >
                                                                                                <InputNumber
                                                                                                    min={0}
                                                                                                    onChange={(value) => {
                                                                                                        // countAbsentTotal(field.name, value)
                                                                                                    }}
                                                                                                />
                                                                                            </Form.Item>
                                                                                            <span>堂</span>
                                                                                        </Space>
                                                                                    </Col>
                                                                                    <Col span={6}>
                                                                                        <Space align='start'>
                                                                                            <Form.Item
                                                                                                label={"學費扣除堂數"}
                                                                                                name={[field.name, "tuition_deduction_classes"]}
                                                                                            >
                                                                                                <InputNumber
                                                                                                    min={0}
                                                                                                    max={5}
                                                                                                    onChange={(value) => {
                                                                                                        counTtuitionDeductionClasses(field.name, value)
                                                                                                    }}
                                                                                                />
                                                                                            </Form.Item>
                                                                                            <span>堂</span>
                                                                                        </Space>
                                                                                    </Col>
                                                                                    <Col span={6}>
                                                                                        <Space align='start'>
                                                                                            <Form.Item
                                                                                                label={"免學費"}
                                                                                                name={[field.name, "is_free_tuition"]}
                                                                                                initialValue={0}
                                                                                            >
                                                                                                <Radio.Group>
                                                                                                    <Radio value={0}>否</Radio>
                                                                                                    <Radio value={1}>是</Radio>
                                                                                                </Radio.Group>
                                                                                            </Form.Item>
                                                                                        </Space>
                                                                                    </Col>
                                                                                    <Col span={20}>
                                                                                        <Row>
                                                                                            <Col span={24}>
                                                                                                <Row>
                                                                                                    <Col>
                                                                                                        <Space align='start'>
                                                                                                            <Form.Item
                                                                                                                label={"分期"}
                                                                                                                name={[field.name, "installment"]}
                                                                                                                initialValue={undefined}
                                                                                                            >
                                                                                                                <Radio.Group>
                                                                                                                    <Radio value={undefined}>否</Radio>
                                                                                                                    <Radio value={1}>是，
                                                                                                                        <Form.Item
                                                                                                                            noStyle
                                                                                                                            initialValue={1}
                                                                                                                            name={[field.name, "installment_count"]}
                                                                                                                        >
                                                                                                                            <InputNumber
                                                                                                                                min={1}
                                                                                                                            />
                                                                                                                        </Form.Item>
                                                                                                                        期</Radio>
                                                                                                                </Radio.Group>
                                                                                                            </Form.Item>
                                                                                                        </Space>
                                                                                                    </Col>
                                                                                                    <Col span={24}>
                                                                                                        <Form.Item>
                                                                                                            <Row>
                                                                                                                <Col span={24}>
                                                                                                                    <Form.List
                                                                                                                        name={[field.name, 'bill_student_installment_data']}
                                                                                                                    >
                                                                                                                        {(subFields, { add, remove }) => (
                                                                                                                            <Col
                                                                                                                                span={24}
                                                                                                                                style={{
                                                                                                                                    display: 'flex',
                                                                                                                                    rowGap: 16,
                                                                                                                                    flexDirection: 'column',
                                                                                                                                }}
                                                                                                                            >
                                                                                                                                {subFields.map((subField) => (
                                                                                                                                    <Space wrap>

                                                                                                                                        <Form.Item
                                                                                                                                            label="期數"
                                                                                                                                            name={[subField.name, "bill_student_installment_serial"]}
                                                                                                                                        >
                                                                                                                                            <Input
                                                                                                                                                style={{
                                                                                                                                                    width: "4rem"
                                                                                                                                                }}

                                                                                                                                                disabled={true}
                                                                                                                                            />
                                                                                                                                        </Form.Item>
                                                                                                                                        <Form.Item
                                                                                                                                            hidden
                                                                                                                                            name={[subField.name, "bill_student_installment_id"]}
                                                                                                                                        >
                                                                                                                                            <Input />
                                                                                                                                        </Form.Item>
                                                                                                                                        <Form.Item
                                                                                                                                            label="繳費金額"
                                                                                                                                            name={[subField.name, "bill_student_cost"]}
                                                                                                                                            rules={[
                                                                                                                                                {
                                                                                                                                                    required: true,
                                                                                                                                                    message: "請填寫繳費金額"
                                                                                                                                                }
                                                                                                                                            ]}
                                                                                                                                        // dependencies={['student_data']}
                                                                                                                                        // rules={[
                                                                                                                                        //     ({ getFieldValue }) => ({
                                                                                                                                        //         validator(_, value) {
                                                                                                                                        //             let bill_student_installment_datas = getFieldValue(['student_data', field.name, 'bill_student_installment_data']) || []
                                                                                                                                        //             let total = getStudentTotal(field.name, count)
                                                                                                                                        //             let bill_student_installment_datas_total = 0
                                                                                                                                        //             bill_student_installment_datas.forEach((value) => {
                                                                                                                                        //                 bill_student_installment_datas_total = parseInt((value?.bill_student_cost || 0)) + bill_student_installment_datas_total
                                                                                                                                        //             })

                                                                                                                                        //             if (parseInt(total) === parseInt(bill_student_installment_datas_total)) {
                                                                                                                                        //                 return Promise.resolve();
                                                                                                                                        //             }
                                                                                                                                        //             return Promise.reject(new Error('分期金額與繳費金額不一致'));
                                                                                                                                        //         },
                                                                                                                                        //     }),
                                                                                                                                        // ]}
                                                                                                                                        >
                                                                                                                                            <InputNumber
                                                                                                                                                min={2}
                                                                                                                                            />
                                                                                                                                        </Form.Item>
                                                                                                                                        <Form.Item
                                                                                                                                            label="個人繳費期限"
                                                                                                                                            name={[subField.name, "payment_limit_time"]}
                                                                                                                                            rules={[
                                                                                                                                                {
                                                                                                                                                    required: true,
                                                                                                                                                    message: "請設定繳費區間"
                                                                                                                                                }
                                                                                                                                            ]}
                                                                                                                                        >
                                                                                                                                            <DatePicker.RangePicker
                                                                                                                                                format={"YYYY-MM-DD"}
                                                                                                                                            />
                                                                                                                                        </Form.Item>
                                                                                                                                        <Form.Item
                                                                                                                                            hidden
                                                                                                                                            label="學生繳費狀態"
                                                                                                                                            name={[subField.name, "payment_status"]}
                                                                                                                                            rules={[
                                                                                                                                                {
                                                                                                                                                    required: true,
                                                                                                                                                    message: "請設定繳費區間"
                                                                                                                                                }
                                                                                                                                            ]}
                                                                                                                                        >
                                                                                                                                            <Input />
                                                                                                                                        </Form.Item>
                                                                                                                                    </Space>
                                                                                                                                ))}
                                                                                                                            </Col>
                                                                                                                        )}
                                                                                                                    </Form.List>
                                                                                                                </Col>
                                                                                                            </Row>

                                                                                                        </Form.Item>
                                                                                                    </Col>
                                                                                                </Row>
                                                                                            </Col>
                                                                                        </Row>
                                                                                    </Col>
                                                                                    <Col span={4}>
                                                                                        <Row>
                                                                                            <Col span={24}>
                                                                                                <Button
                                                                                                    onClick={() => {
                                                                                                        if (canExport) {
                                                                                                            exportBillPaymentClassPdf(field.name)
                                                                                                        }
                                                                                                        else {
                                                                                                            message.info("需先進行儲存後，才能匯出繳費單")
                                                                                                        }
                                                                                                    }}
                                                                                                >
                                                                                                    匯出
                                                                                                </Button>
                                                                                            </Col>
                                                                                            <Col
                                                                                                span={24}
                                                                                            >
                                                                                                <Card
                                                                                                    size={"small"}
                                                                                                    style={{
                                                                                                        marginTop: 16,
                                                                                                    }}
                                                                                                    type="inner"
                                                                                                    title="本期總額"
                                                                                                >
                                                                                                    {getStudentTotal(field.name, count)['CourseFees'] + getStudentTotal(field.name, count)['OtherFees'] || 0}元
                                                                                                </Card>
                                                                                            </Col>
                                                                                        </Row>
                                                                                    </Col>
                                                                                </Row>
                                                                            </Col>
                                                                        </Row>
                                                                    </Col>
                                                                    <Col>
                                                                        <Form.Item
                                                                            name={[field.name, "grade_class_id"]}
                                                                            hidden
                                                                        >
                                                                            <Input />
                                                                        </Form.Item>
                                                                    </Col>
                                                                    <Col>
                                                                        <Form.Item
                                                                            name={[field.name, "grade_class_student_id"]}
                                                                            hidden
                                                                        >
                                                                            <Input />
                                                                        </Form.Item>
                                                                    </Col>
                                                                    <Col
                                                                        span={24}
                                                                    >
                                                                        <Row
                                                                            justify={'center'}
                                                                            gutter={[0, 24]}
                                                                        >
                                                                            <Col span={24}>
                                                                                <Row>
                                                                                    <Col span={24}>
                                                                                        <Form.Item>
                                                                                            <Form.List
                                                                                                name={[field.name, 'bill_payment_grade_class_student_Salary_TABLE_Formula_data']}
                                                                                            >
                                                                                                {(subFields, { add, remove }) => (
                                                                                                    <Col
                                                                                                        span={24}
                                                                                                        style={{
                                                                                                            display: 'flex',
                                                                                                            rowGap: 16,
                                                                                                            flexDirection: 'column',
                                                                                                        }}
                                                                                                    >
                                                                                                        <Button
                                                                                                            onClick={() => {
                                                                                                                add()
                                                                                                            }}
                                                                                                            type="primary"
                                                                                                            style={{
                                                                                                                marginBottom: 16,
                                                                                                                color: 'white',
                                                                                                                backgroundColor: '#2C73D2'
                                                                                                            }}
                                                                                                            shape='round'
                                                                                                            data-function="add"
                                                                                                        >
                                                                                                            新增個別繳費明細
                                                                                                        </Button>

                                                                                                        {subFields.map((subField) => (
                                                                                                            <Space wrap>
                                                                                                                <Form.Item
                                                                                                                    hidden
                                                                                                                    name={[subField.name, "bill_payment_grade_class_student_Salary_TABLE_Formula_id"]}
                                                                                                                >
                                                                                                                    <InputNumber />
                                                                                                                </Form.Item>
                                                                                                                <Form.Item
                                                                                                                    name={[subField.name, "iUnitID"]}
                                                                                                                    hidden
                                                                                                                >
                                                                                                                    <Input />
                                                                                                                </Form.Item>
                                                                                                                <Form.Item
                                                                                                                    name={[subField.name, "iUnitValue"]}
                                                                                                                    hidden
                                                                                                                >
                                                                                                                    <Input />
                                                                                                                </Form.Item>
                                                                                                                <Form.Item
                                                                                                                    label="cUnitName"
                                                                                                                    name={[subField.name, "cUnitName"]}
                                                                                                                    hidden
                                                                                                                >
                                                                                                                    <Input />
                                                                                                                </Form.Item>
                                                                                                                <Form.Item
                                                                                                                    name={[subField.name, "cName"]}
                                                                                                                    hidden
                                                                                                                >
                                                                                                                    <Input

                                                                                                                    />
                                                                                                                </Form.Item>
                                                                                                                <Form.Item
                                                                                                                    name={[subField.name, "iRuleID"]}
                                                                                                                    hidden
                                                                                                                >
                                                                                                                    <InputNumber

                                                                                                                    />
                                                                                                                </Form.Item>
                                                                                                                <Form.Item
                                                                                                                    name={[subField.name, "iFormulaID_children"]}
                                                                                                                    hidden
                                                                                                                >
                                                                                                                    <InputNumber

                                                                                                                    />
                                                                                                                </Form.Item>

                                                                                                                <Form.Item
                                                                                                                    name={[subField.name, "iSign"]}
                                                                                                                    hidden
                                                                                                                    initialValue={1}
                                                                                                                >
                                                                                                                    <InputNumber

                                                                                                                    />
                                                                                                                </Form.Item>
                                                                                                                <Form.Item
                                                                                                                    name={[subField.name, "iFormulaType"]}
                                                                                                                    hidden
                                                                                                                >
                                                                                                                    <InputNumber

                                                                                                                    />
                                                                                                                </Form.Item>
                                                                                                                <Form.Item
                                                                                                                    label="項目"
                                                                                                                    name={[subField.name, 'iFormulaID']}
                                                                                                                    rules={[
                                                                                                                        {
                                                                                                                            required: true,
                                                                                                                            message: "請選擇 （必填)"
                                                                                                                        }
                                                                                                                    ]}
                                                                                                                >
                                                                                                                    <Select
                                                                                                                        popupMatchSelectWidth={false}
                                                                                                                        options={formulaOption}
                                                                                                                        onChange={(value) => {
                                                                                                                            onChangeStudentiFormulaID(field.name, subField.name, value)
                                                                                                                        }}
                                                                                                                    >
                                                                                                                    </Select>
                                                                                                                </Form.Item>


                                                                                                                <Form.Item
                                                                                                                    initialValue={0}
                                                                                                                    name={[subField.name, "tempPrice"]}
                                                                                                                    hidden
                                                                                                                >
                                                                                                                    <InputNumber
                                                                                                                    />
                                                                                                                </Form.Item>
                                                                                                                <Form.Item
                                                                                                                >
                                                                                                                    <>*</>
                                                                                                                </Form.Item>
                                                                                                                <Form.Item
                                                                                                                    name={[subField.name, "amount"]}
                                                                                                                    rules={[
                                                                                                                        {
                                                                                                                            required: true,
                                                                                                                            message: "（必填)"
                                                                                                                        }
                                                                                                                    ]}
                                                                                                                >
                                                                                                                    <InputNumber
                                                                                                                        onChange={() => {
                                                                                                                            // onItemChange()
                                                                                                                        }}
                                                                                                                    />
                                                                                                                </Form.Item>

                                                                                                                <Form.Item
                                                                                                                    initialValue={"+"}
                                                                                                                    name={[subField.name, 'cOperator']}
                                                                                                                    rules={[
                                                                                                                        {
                                                                                                                            required: true,
                                                                                                                            message: "請選擇 （必填)"
                                                                                                                        }
                                                                                                                    ]}
                                                                                                                >
                                                                                                                    <Select
                                                                                                                        options={[
                                                                                                                            {
                                                                                                                                label: "+",
                                                                                                                                value: "+"
                                                                                                                            },
                                                                                                                            {
                                                                                                                                label: "-",
                                                                                                                                value: "-"
                                                                                                                            },
                                                                                                                            {
                                                                                                                                label: "*",
                                                                                                                                value: "*"
                                                                                                                            },
                                                                                                                            {
                                                                                                                                label: "/",
                                                                                                                                value: "/"
                                                                                                                            },
                                                                                                                        ]}
                                                                                                                        onChange={(e) => {
                                                                                                                            // onItemChange()
                                                                                                                        }}
                                                                                                                    ></Select>
                                                                                                                </Form.Item>
                                                                                                                <Form.Item
                                                                                                                    initialValue={0}
                                                                                                                    name={[subField.name, "fNumeric"]}
                                                                                                                >
                                                                                                                    <InputNumber

                                                                                                                    />
                                                                                                                </Form.Item>
                                                                                                                <Form.Item
                                                                                                                >
                                                                                                                    =
                                                                                                                </Form.Item>
                                                                                                                <Form.Item>
                                                                                                                </Form.Item>
                                                                                                                <Form.Item
                                                                                                                    name={[subField.name, "lesson_Salary_TABLE_Formula_id"]}
                                                                                                                >
                                                                                                                    {getStudentSubTotal(field.name, subField.name, count) || 0}

                                                                                                                </Form.Item>
                                                                                                                <Form.Item>
                                                                                                                    {
                                                                                                                        <DeleteOutlined
                                                                                                                            style={{ cursor: 'pointer' }}
                                                                                                                            onClick={() => {
                                                                                                                                remove(subField.name);
                                                                                                                            }}
                                                                                                                        />
                                                                                                                    }
                                                                                                                </Form.Item>
                                                                                                            </Space>
                                                                                                        ))}
                                                                                                    </Col>
                                                                                                )}
                                                                                            </Form.List>
                                                                                        </Form.Item>

                                                                                    </Col>
                                                                                </Row>
                                                                            </Col>
                                                                        </Row>
                                                                    </Col>

                                                                </Row>
                                                            </Card>
                                                        </Col>
                                                    ))}
                                            </Row>
                                        )}
                                    </Form.List>
                                </Col>
                            </Row>
                        </Col>
                    </Row>



                </Form>
            </Col>
        </Row>)
}
export default AddTuitionForm;